<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { isPhone } from "@/DeviceInfoPlugin";
import Constants from "@/Constants";
import { Globals } from "@/Globals";
import { checkBegriff, checkNode, globalsKennung, globalsStt } from "@/local";
import { getKZValueDisplay, getKZTitle, getKZValue } from "@/DataHelper";
import { DialogParameter, showDialog } from "@/UIHelper";
import { showPDF2, showImage } from "@/PdfHelper";
import { writeTempFileAndOpen } from "@/FileHelper";
import {
  mountedBase,
  BaseSetup,
  reloadData,
  onDelete,
} from "@/DataLoaderStatic";

const props = defineProps<{
  aicReise?: number;
  nameReise?: string;
  editQuery?: string;
  contentHeight?: number;
  setSperre?: boolean;
  editMask?: string;
  query?: string;
  keinNodeBeleg?: boolean;
}>();
const emit = defineEmits<{
  back: [];
  onReloadData: [data?: any];
  calculated: [data?: any];
}>();

let sperre: boolean = false; // dürfen Tage nicht mehr bearbeitet werden- dann wird sperre gesetzt
let itemHeight = ref<string>("110");

let heightLocal = ref<number>(props.contentHeight ?? innerHeight);
let items = ref<ListItems[]>([]);
let base64data = ref("");
const mimeType = ref("image/jpg");
let belegeAzure = false;
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_ManuelleKostenerfassung",
  backOnDelete: true,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (props.query) {
    pageParams.query = props.query;
  }
  if (!props.keinNodeBeleg) {
    // aus Buchungen - Belege - muss hier km GElD angezeigt werden!
    if (checkNode("RK_Belegerkennung")) {
      belegeAzure = true;
      if (props.aicReise) {
        pageParams.query = "Web_UebersichtBelegeProReise";
        pageParams.queryAIC = props.aicReise;
      } else {
        pageParams.query = "Web_UebersichtBelege";
      }
    }
  }
  const Stamm = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
  if (props.aicReise) {
    AUApi.Current.setSyncStamm(Stamm.aic, props.aicReise);
    if (!pageParams.jokerStt) {
      pageParams.jokerStt = [];
    }
    pageParams.jokerStt.push({
      sync: props.aicReise, // aic Stammsatz
      aic: Stamm.aic, // aic Stammtyp
    });
  }
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data) {
    await refreshItems();
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
async function refreshItems() {
  items.value = []; // ausleeren für refresh

  for (let i = 0; i < uiData.data.length; i++) {
    const row = uiData.data[i];
    const header = getKZValueDisplay(row, "header", uiData.columns);

    let title = getKZValueDisplay(row, "titel", uiData.columns);
    if (title) {
      const textTitle = getKZTitle(row, "titel", uiData.columns);
      title = textTitle + ": " + title;
    }
    let title2 = getKZValueDisplay(row, "title2", uiData.columns);

    if (title2) {
      const textTitle2 = getKZTitle(row, "title2", uiData.columns);
      title2 = textTitle2 + ": " + title2;
    }
    let subtitel = getKZValueDisplay(row, "subtitel", uiData.columns);
    if (subtitel) {
      const textSubtitel = getKZTitle(row, "subtitel", uiData.columns);
      subtitel = textSubtitel + ": " + subtitel;
    }
    let subtitel1 = getKZValueDisplay(row, "subtitel1", uiData.columns);
    if (!subtitel1) {
      subtitel1 = getKZValueDisplay(row, "subtitle1", uiData.columns);
    }

    if (subtitel1) {
      const textSubtitel1 = getKZTitle(row, "subtitle1", uiData.columns);
      subtitel1 = textSubtitel1 + ": " + subtitel1;
    }
    let text = getKZValueDisplay(row, "text", uiData.columns);
    if (text) {
      const textTitel = getKZTitle(row, "text", uiData.columns);
      text = textTitel + ": " + text;
    }
    let icon = getKZValueDisplay(row, "icon", uiData.columns);

    const sperre = getKZValue(row, "sperre", uiData.columns);
    let noDelete = false;
    const allowDelete = getKZValue(row, "allowDelete", uiData.columns);
    if (!allowDelete) {
      noDelete = true;
    }
    let pdf = getKZValue(row, "pdf", uiData.columns);
    let memo = "";
    let checkbox = false;
    if (pdf && pdf.name && pdf?.type !== "application/pdf") {
      memo = pdf.name;
      icon = pdf;
      pdf = loadImage(pdf);
      itemHeight.value = "120";
    } else {
      checkbox = true;
    }
    const ampel = getKZValue(row, "ampel", uiData.columns);
    let color = "grey";
    if (ampel === 0) {
      color = "grey";
    } else if (ampel === 1) {
      color = "green";
    } else if (ampel === 2) {
      color = "orange";
    } else if (ampel === 3) {
      color = "red";
    }
    if (pdf) {
      mimeType.value = pdf.type ?? "image/jpg";
    }
    items.value.push({
      header,
      title,
      title2,
      subtitel,
      subtitel1,
      text,
      icon,
      divider: true,
      inset: true,
      aic: row.aic_Bew_pool ?? row.aic_Stamm ?? 0,
      menu: false,
      pdf,
      memo,
      checkbox,
      sperre,
      ampel,
      color,
      noDelete,
    });
  }
}
function openNew(bewegungsdaten: boolean) {
  let editQuery = props.editQuery;

  if (belegeAzure) {
    editQuery = "Web_neuerBeleg_automBelegErkennung";
    if (props.aicReise) {
      editQuery = "Web_neuerBelegReisen_Azure";
    }
  }
  let showFullscreen = false;
  if (Constants.isMobile && isPhone()) {
    showFullscreen = true;
  }
  const title = props.nameReise ?? "erfassen";
  let site = "RkMitarbeiterEditKostenersatz";
  if (props.editMask) {
    site = props.editMask;
  }
  showDialog({
    title,
    site,
    width: 400,
    fullscreen: showFullscreen,
    data: {
      zeitbereich: pageParams.zeitbereich,
      aicBewegung: "0",
      aicReise: props.aicReise,
      bewegungsdaten,
      editQuery,
      belegeAzure,
      newData: true,
    },
    onClose: (x: DialogParameter) => {
      completeReload();
      return true;
    },
  });
}
function openEdit(aicBewegung: number) {
  let showFullscreen = false;
  let bewegungsdaten = true;
  let editQuery = props.editQuery;
  let stammQuery = "";
  let auswahlQuery = "";
  let neuDialog = "";

  if (Constants.isMobile && isPhone()) {
    showFullscreen = true;
  }
  let site = "RkMitarbeiterEditKostenersatz";
  if (props.editMask) {
    site = props.editMask;
  }
  if (belegeAzure) {
    site = "BaseStammMaske";
    const formular = globalsKennung(Globals.Begriff, "Web_RK_Stammdaten_Beleg");
    stammQuery = formular.stammQuery ?? "";
    auswahlQuery = formular.auswahlQuery ?? "";
    neuDialog = formular.neuDialog ?? "";
    editQuery = formular.query;
    // editQuery = "Web_EditBeleg_Belegerkennung";
    bewegungsdaten = false;
    showFullscreen = true;
  }
  showDialog({
    title: "bearbeiten",
    site,
    width: 400,
    fullscreen: showFullscreen,
    data: {
      zeitbereich: pageParams.zeitbereich,
      aicBewegung,
      aic: aicBewegung,
      aicReise: props.aicReise,
      bewegungsdaten,
      showDelete: true,
      editQuery,
      belegeAzure,
      stammQuery,
      auswahlQuery,
      neuDialog,
      neuErfassung: false,
    },
    onClose: (x: DialogParameter) => {
      completeReload();
      const dataSaved = true;
      emit("onReloadData", { dataSaved });
      return true;
    },
  });
}
async function completeReload() {
  await reloadData(uiData, pageParams);
  await refreshItems();
}
async function onDeleteAndRefresh(aic: number) {
  await onDelete(uiData, pageParams, aic, "", "");
  await completeReload();
}
function loadImage(image: any) {
  if (image.datentyp === "Doku") {
    const base64dataLocal = AUApi.Current.fullUrl(
      "pdf2/" + AUApi.Current.user.id + ":" + +image.aic + "_" + image.name,
    );
    return base64dataLocal;
  } else {
    const base64dataLocal = AUApi.Current.fullUrl(
      "image2/" + AUApi.Current.user.id + ":" + +image.aic + "_" + image.name,
    );
    return base64dataLocal;
  }
}
function onShowPdf(pdf: any) {
  showPDF2(pdf.name, pdf.aic, AUApi.Current.user.id);
}
async function onShowImage(image: any) {
  if (image?.aic)
    showImage(image, image.aic, AUApi.Current.user.id, mimeType.value);
  else {
    // wenn kein AIC dann lokal
    writeTempFileAndOpen("preview.tmp", mimeType.value, base64data.value);
  }
}
</script>
<template>
  <v-card :loading="uiData.showLoading" class="pa-0">
    <v-list v-if="uiData.initialized">
      <v-virtual-scroll
        v-if="items && items.length > 0"
        benched="0"
        :items="items"
        :height="contentHeight"
        :item-height="itemHeight"
      >
        <template v-slot:default="{ item }">
          <v-list-item ref="liste" :key="item.title" style="text-align: left">
            <template v-slot:prepend>
              <v-icon v-if="item.ampel" size="x-large" :color="item.color"
                >mdi-circle-slice-8</v-icon
              >
            </template>
            <v-list-item-title>{{ item.header }}</v-list-item-title>

            <v-list-item-subtitle>{{ item.title }} </v-list-item-subtitle>
            <v-list-item-subtitle> {{ item.title2 }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.subtitel }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.subtitel1 }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
            <v-list-item-action class="align-end">
              <v-spacer></v-spacer>
              <v-img
                v-if="item.memo"
                :src="item.pdf"
                :aspect-ratio="16 / 9"
                style="max-width: 80px; max-height: 50px"
                @click="onShowImage(item.icon)"
                contain
              />
              <v-btn
                size="x-large"
                variant="text"
                v-if="item.pdf && item.checkbox"
                @click="onShowPdf(item.pdf)"
                ><v-icon>mdi-file-pdf-box</v-icon></v-btn
              >

              <v-btn
                v-if="
                  (item.aic && !setSperre && !item.sperre) ||
                  (belegeAzure && item.aic)
                "
                variant="text"
                @click.prevent.stop="openEdit(item.aic)"
              >
                <v-icon color="success" small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="belegeAzure && item.aic && !item.noDelete"
                icon="mdi-delete"
                variant="text"
                size="small"
                color="red"
                @click="onDeleteAndRefresh(item.aic ?? 0)"
                :disabled="item.noDelete"
              >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider :inset="true"></v-divider>
        </template>
      </v-virtual-scroll>
    </v-list>
    <v-card-actions class="pa-0">
      <v-spacer></v-spacer>
      <v-btn
        v-if="belegeAzure"
        class="mb-10"
        color="info"
        size="small"
        variant="elevated"
        @click="completeReload()"
        icon="mdi-refresh"
      >
      </v-btn>
      <v-btn
        v-if="!setSperre"
        class="mb-10"
        color="info"
        variant="elevated"
        size="small"
        @click.prevent.stop="openNew(false)"
        icon="mdi-plus"
      >
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.scroll {
  overflow-y: auto;
}
</style>
